import * as React from 'react';

const AWSIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height={30} viewBox="0 0 48 30" width={48} xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M13.5263 11.0714C13.5263 11.6623 13.5906 12.1414 13.7023 12.4919C13.8294 12.8424
            13.9901 13.2266 14.2136 13.6414C14.2932 13.7685 14.3253 13.8971 14.3253 
            14.0088C14.3253 14.168 14.2289 14.3287 14.0222 14.4879L13.0166 15.1584C12.8727 
            15.2548 12.7288 15.3022 12.6018 15.3022C12.4426 15.3022 12.2818 15.2227 12.1227 
            15.0788C11.8992 14.84 11.7078 14.5844 11.5486 14.3287C11.3895 14.0578 11.2287 
            13.7547 11.0542 13.3874C9.80825 14.8568 8.24388 15.59 6.36113 15.59C5.02024 
            15.59 3.95029 15.2073 3.1681 14.4405C2.38592 13.6736 1.98641 12.6526 1.98641 
            11.376C1.98641 10.0198 2.46551 8.91773 3.43904 8.08809C4.41256 7.25846 5.70599 
            6.84364 7.34996 6.84364C7.89335 6.84364 8.45205 6.89109 9.0429 6.97069C9.63375 
            7.05028 10.2399 7.17886 10.8782 7.32122V6.15636C10.8782 4.94252 10.6226 4.09758
            10.1282 3.60163C9.61691 3.10722 8.75513 2.8669 7.52599 2.8669C6.96728 2.8669 
            6.39327 2.93119 5.80243 3.07507C5.21158 3.21896 4.63757 3.39499 4.07887 
            3.61847C3.82324 3.73021 3.6319 3.7945 3.52016 3.82664C3.40842 3.85879 3.32883 
            3.8741 3.26454 3.8741C3.04106 3.8741 2.92931 3.7149 2.92931 3.37968V2.5975C2.92931 
            2.34187 2.96146 2.15054 3.04106 2.03879C3.12065 1.92705 3.26454 1.81531 3.48802 
            1.70357C4.04672 1.4158 4.71716 1.17701 5.49935 0.985678C6.28153 0.777504 7.11117 
            0.682601 7.98978 0.682601C9.88937 0.682601 11.2777 1.11426 12.1716 1.97604C13.0503 
            2.83782 13.4972 4.14656 13.4972 5.90379V11.076H13.5294L13.5263 11.0714ZM7.04535 
            13.4991C7.57191 13.4991 8.1153 13.4027 8.68931 13.2113C9.26332 13.02 9.77457 
            12.6679 10.2062 12.1903C10.4619 11.8873 10.6532 11.552 10.7496 11.1694C10.8461 
            10.7867 10.9088 10.3229 10.9088 9.78104V9.11059C10.4465 8.99885 9.9506 8.90242
            9.43935 8.83966C8.9281 8.7769 8.43369 8.74323 7.93927 8.74323C6.86932 8.74323
            6.08713 8.9514 5.56058 9.38153C5.03402 9.81165 4.77839 10.4193 4.77839 11.2168C4.77839
            11.9669 4.96973 12.5256 5.36924 12.9082C5.75191 13.3078 6.31062 13.4991 7.04535 
            13.4991ZM19.8634 15.2227C19.5756 15.2227 19.3843 15.1752 19.2572 15.0635C19.1302 
            14.967 19.0184 14.7435 18.922 14.4405L15.1703 2.10002C15.0738 1.78011 15.0264 
            1.57346 15.0264 1.46172C15.0264 1.2061 15.1534 1.06221 15.4091 1.06221H16.9734C17.2765 
            1.06221 17.4847 1.10966 17.5964 1.2214C17.7235 1.31784 17.8199 1.54132 17.9163 
            1.8444L20.5981 12.4123L23.0885 1.8444C23.1681 1.52448 23.2646 1.31784 23.3916 
            1.2214C23.5187 1.12497 23.7421 1.06221 24.0299 1.06221H25.3065C25.6096 1.06221 
            25.8178 1.10966 25.9448 1.2214C26.0719 1.31784 26.1836 1.54132 26.2479 1.8444L28.7705
            12.5409L31.5318 1.8444C31.6283 1.52448 31.74 1.31784 31.8518 1.2214C31.9788 1.12497 
            32.187 1.06221 32.4747 1.06221H33.9595C34.2151 1.06221 34.359 1.18926 34.359 
            1.46172C34.359 1.54132 34.3437 1.62092 34.3269 1.71735C34.31 1.81378 34.2794 
            1.94083 34.2151 2.11686L30.367 14.4573C30.2705 14.7772 30.1588 14.9839 30.0318 
            15.0803C29.9047 15.1767 29.6965 15.2395 29.4256 15.2395H28.0526C27.7495 15.2395 
            27.5413 15.192 27.4143 15.0803C27.2872 14.9686 27.1755 14.7604 27.1112 14.442L24.6361
            4.14503L22.1778 14.4252C22.0982 14.7451 22.0017 14.9517 21.8747 15.0635C21.7477
            15.1752 21.5242 15.2227 21.2364 15.2227H19.8634ZM40.3777 15.6543C39.5481 15.6543
            38.7169 15.5579 37.9194 15.3665C37.1219 15.1752 36.4989 14.967 36.0841 14.7282C35.8285
            14.5844 35.6525 14.4252 35.5897 14.2813C35.5269 14.1374 35.4933 13.9782 35.4933 
            13.8343V13.02C35.4933 12.6848 35.6203 12.5256 35.8606 12.5256C35.9571 12.5256 36.052
            12.5409 36.1484 12.573C36.2448 12.6052 36.3872 12.6695 36.5479 12.7322C37.0913
            12.971 37.6822 13.1639 38.3036 13.2909C38.9419 13.418 39.5649 13.4823 40.2032
            13.4823C41.2089 13.4823 41.9911 13.3062 42.5345 12.9557C43.0779 12.6052
            43.3641 12.0939 43.3641 11.4388C43.3641 10.9918 43.2202 10.6245 42.9324
            10.3214C42.6447 10.0183 42.1028 9.74736 41.3206 9.49174L39.0062 8.77384C37.8414
            8.40648 36.978 7.86461 36.4515 7.14519C35.9249 6.4426 35.654 5.66041 
            35.654 4.83078C35.654 4.16034 35.7979 3.56949 36.0856 3.05824C36.3734
            2.54699 36.7561 2.10002 37.2352 1.74949C37.7143 1.38213 38.2562 1.1112
            38.896 0.919858C39.5358 0.728522 40.2047 0.648926 40.9073 0.648926C41.2579
            0.648926 41.6252 0.664232 41.9773 0.713215C42.3447 0.760666 42.6799 0.824956
            43.0151 0.889245C43.335 0.968841 43.6381 1.04844 43.9243 1.14487C44.2106
            1.2413 44.4356 1.33621 44.5948 1.43264C44.8183 1.55969 44.9774 1.68827
            45.0739 1.83215C45.1703 1.9592 45.2178 2.13523 45.2178 2.35871V3.10875C45.2178 
            3.44397 45.0907 3.62 44.8504 3.62C44.7233 3.62 44.5152 3.55571 44.2442 3.42866C43.335 
            3.01385 42.3125 2.80567 41.1798 2.80567C40.2706 2.80567 39.5511 2.94956 39.0567 
            3.25263C38.5623 3.55571 38.3067 4.01951 38.3067 4.67312C38.3067 5.12008 38.4659 5.50275 
            38.7858 5.80736C39.1057 6.11197 39.695 6.41351 40.5415 6.68598L42.8085 7.40387C43.958 7.77124 
            44.7876 8.28249 45.2836 8.9361C45.7795 9.5897 46.0183 10.3413 46.0183 11.1709C46.0183 11.8567 
            45.8744 12.4796 45.6035 13.023C45.3157 13.5664 44.9331 14.044 44.4386 14.4282C43.9442 14.8277
            43.3534 15.114 42.6661 15.3221C41.9482 15.5456 41.1982 15.6574 40.3838 15.6574L40.3777 15.6543Z"
            fill="white"
        />
        <path
            d="M43.3947 23.4119C38.1429 27.2906 30.5124 29.3509 23.9503 29.3509C14.7554 29.3509 
            6.46981 25.9513 0.212335 20.3C-0.282079 19.853 0.164884 19.2468 0.755731 19.5974C7.52445
            23.5251 15.8744 25.9038 24.5106 25.9038C30.3379 25.9038 36.7393 24.69 42.6294 22.1995C43.508 
            21.8 44.258 22.7736 43.3962 23.4134L43.3947 23.4119Z"
            fill="white"
        />
        <path
            d="M45.5821 20.9214C44.9116 20.0596 41.1446 20.5066 39.4363 20.7132C38.9251 20.7775 
            38.8455 20.3306 39.3093 19.9954C42.311 17.8876 47.2429 18.4953 47.8184 19.1979C48.3924
            19.9158 47.6592 24.8492 44.8489 27.2126C44.4172 27.5799 44.0024 27.3886 44.1937 
            26.9095C44.832 25.3298 46.2525 21.7694 45.5821 20.923V20.9214Z"
            fill="white"
        />
    </svg>
);
export default AWSIcon;
